export enum CoreHeaderToggleMask {
  NONE = 0,
  OFF = 1 << 0,
  NAVIGATION = 1 << 1,
  MENUS = 1 << 2,
}
